// src/pages/Login/formLogin/formLogin.jsx
import React from 'react';

export default function FormLogin({
  icone,
  user,
  password,
  errorMessage,
  onChangeUser,
  onChangePassword,
  onSubmit,
  onClickRegister,
  onClickForgotPassword,
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-green-100 to-emerald-100 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          {/*<img
            src={icone}
            alt="Logo"
            className="mx-auto h-24 w-auto transition-transform duration-300 hover:scale-110 drop-shadow-lg"
          />*/}
          <h2 className="mt-6 text-[5vh] font-bold text-gray-800 tracking-tight">
            Acesso ao SAP
          </h2>
          <p className="mt-2 text-[2.5vh] text-gray-600">
            Entre com suas credenciais
          </p>
        </div>

        <div className="p-0">
          {errorMessage && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200">
              <p className="text-red-700 text-sm font-medium">{errorMessage}</p>
            </div>
          )}

          <form onSubmit={onSubmit} className="space-y-6">
            <div>
              <p className="text-gray-700 font-semibold text-[2vh] mb-2">Usuário</p>
              <label htmlFor="user" className="sr-only">
                Nome de usuário
              </label>
              <input
                id="user"
                type="text"
                required
                value={user}
                onChange={onChangeUser}
                className="w-full px-5 py-3.5 border border-green-300 rounded-xl focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200 bg-white/70 backdrop-blur-sm placeholder-gray-500 text-gray-800"
                placeholder="Nome de usuário"
              />
            </div>

            <div>
              <p className="text-gray-700 font-semibold text-[2vh] mb-2">Senha</p>
              <label htmlFor="password" className="sr-only">
                Senha
              </label>
              <input
                id="password"
                type="password"
                required
                value={password}
                onChange={onChangePassword}
                className="w-full px-5 py-3.5 border border-green-300 rounded-xl focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200 bg-white/70 backdrop-blur-sm placeholder-gray-500 text-gray-800"
                placeholder="Senha"
              />
            </div>

            <div className="flex flex-col sm:flex-row gap-3 text-sm">
              <button
                type="button"
                onClick={onClickRegister}
                className="text-[1.8vh] flex-1 text-primary-600 hover:text-primary-700 font-medium transition-colors duração-200 py-[0.3vh] px-[0.3vw] rounded-lg hover:bg-primary-50"
              >
                Cadastrar-se
              </button>
              <button
                type="button"
                onClick={onClickForgotPassword}
                className="text-[1.85vh] flex-1 text-primary-600 hover:text-primary-700 font-medium transition-colors duração-200 py-[0.3vh] px-[0.3vw] rounded-lg hover:bg-primary-50"
              >
                Esqueceu a Senha?
              </button>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-primary-500 to-primary-600 text-white py-3 px-4 rounded-xl font-semibold text-lg shadow-lg hover:from-primary-600 hover:to-primary-700 focus:ring-4 focus:ring-primary-200 transition-all duration-200 transform hover:scale-[1.02] active:scale-95"
            >
              <span className="flex items-center justify-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
                Entrar no Sistema
              </span>
            </button>
          </form>
        </div>

        <div className="text-center">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} CMD Automação
          </p>
        </div>
      </div>
    </div>
  );
}
